import { z } from "zod";

/** The one list of error codes the API answers with. A route never invents a code; it picks one here. */
export const ERROR_CODES = [
  "bad_request", // the body or query failed its zod schema; details carries the issues
  "unauthenticated", // no session
  "forbidden", // a session, but not this workspace or not this capability
  "not_found",
  "conflict", // a unique value is taken (slug, email)
  "rate_limited",
  "reserved_slug",
  "plan_limit", // M7 round one: the plan's cap is reached (details: plan, limit, max, used)
  "plan_feature", // M7 round one: the plan does not include the feature (details: plan, feature)
  "no_credits", // M7 round three: the AI's work needs credits the workspace has not got (details: balance, needed, available)
  "gone", // M6 round one: an export archive past its seven days
  "internal",
] as const;
export type ErrorCode = (typeof ERROR_CODES)[number];

export const ApiErrorSchema = z.object({
  error: z.object({ code: z.enum(ERROR_CODES), message: z.string(), details: z.unknown().optional() }),
});
export type ApiError = z.infer<typeof ApiErrorSchema>;

/** The HTTP status each code travels with. */
export const ERROR_STATUS: Record<ErrorCode, number> = {
  bad_request: 400, unauthenticated: 401, forbidden: 403, not_found: 404, conflict: 409, rate_limited: 429, reserved_slug: 422, gone: 410, internal: 500, plan_limit: 403, plan_feature: 403, no_credits: 403, // "Work my queue" round one: no_connection went with "Hand to my AI"
};

export function apiError(code: ErrorCode, message: string, details?: unknown): ApiError {
  return { error: details === undefined ? { code, message } : { code, message, details } };
}
